import { isNil } from '@lucidlink/tscore';
import { HTTPScheme } from '#common/types';
export const AZURE_EMULATOR_ENDPOINT_SUFFIX = 'UseDevelopmentStorage=true';
const AZURE_DEFAULT_ENDPOINT_SUFFIX = 'core.windows.net';
const AZURE_EMULATOR_ENDPOINT = '127.0.0.1:10000/devstoreaccount1';
export const constructBaseUrl = (accessKey, httpScheme, endpointOverride) => {
    if (endpointOverride === AZURE_EMULATOR_ENDPOINT_SUFFIX) {
        const scheme = httpScheme == HTTPScheme.HTTPS ? 'https' : 'http';
        const baseUrl = `${scheme}://${AZURE_EMULATOR_ENDPOINT}`;
        return baseUrl;
    }
    const endpointSuffix = getEndpointSuffix(endpointOverride);
    const scheme = httpScheme == HTTPScheme.HTTPS ? 'https' : 'http';
    const baseUrl = `${scheme}://${accessKey}.blob.${endpointSuffix}`;
    return baseUrl;
};
const getEndpointSuffix = (endpointOverride) => {
    if (isNil(endpointOverride) || endpointOverride === '') {
        return AZURE_DEFAULT_ENDPOINT_SUFFIX;
    }
    return endpointOverride;
};
